async function zakekePostprocessProperties(props, context) {
  const params = new URLSearchParams(window.location.search);
  const linkedVariant = params.get("linked_chair");

  if (linkedVariant) {
    props['_linked_chair_variant_id'] = linkedVariant;
  }

  // Store combo chain in sessionStorage so the relay script on the next page
  // can pick it up and redirect — works even when Zakeke adds to cart server-side.
  const comboChain = params.get("combo_chain");
  if (comboChain && linkedVariant) {
    sessionStorage.setItem('_zk_chain', comboChain);
    sessionStorage.setItem('_zk_lv', linkedVariant);
  }

  return props;
}

// ─── Branded loading screen between combo steps ───────────────────────────────
function showTransitionOverlay(nextHandle, onReady) {
  var label = nextHandle
    .replace(/ttracing-?/i, '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, function (c) { return c.toUpperCase(); });

  var style = document.createElement('style');
  style.textContent = [
    '#zt-overlay{',
      'position:fixed;inset:0;',
      'background:rgba(255,255,255,0.97);',
      'display:flex;align-items:center;justify-content:center;',
      'z-index:2147483647;',
      'opacity:0;transition:opacity .25s ease;',
    '}',
    '#zt-overlay.zt-visible{opacity:1}',
    '.zt-box{text-align:center;font-family:Gotham,sans-serif;padding:32px}',
    '.zt-step-label{font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#ee1b24;margin-bottom:24px}',
    '.zt-spinner{width:48px;height:48px;border:3px solid #f0f0f0;border-top-color:#ee1b24;border-radius:50%;animation:zt-spin .75s linear infinite;margin:0 auto 20px}',
    '.zt-title{font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 6px}',
    '.zt-sub{font-size:13px;color:#888;margin:0}',
    '@keyframes zt-spin{to{transform:rotate(360deg)}}'
  ].join('');

  var overlay = document.createElement('div');
  overlay.id = 'zt-overlay';
  overlay.innerHTML = [
    '<div class="zt-box">',
      '<p class="zt-step-label">Next Up</p>',
      '<div class="zt-spinner"></div>',
      '<p class="zt-title">Loading ' + label + ' Customizer</p>',
      '<p class="zt-sub">Preparing your next design&hellip;</p>',
    '</div>'
  ].join('');

  document.head.appendChild(style);
  document.body.appendChild(overlay);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      overlay.classList.add('zt-visible');
      setTimeout(onReady, 350);
    });
  });
}
